<template>

  <div>
    <xolas-table
    table-ref="rentalduetable"

    url="/report/property/due"
    :fields="fields"

    title="Tenancy Due"
    icon="fa fa-asterisk"

    search-placeholder="Site name, Landlord..."
     />

    <events-calendar category="tenancy" />

</div>
</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import EventsCalendar from '@/components/atoms/EventsCalendar'

export default {
  mixins: [DateMixins, NumberMixins],

  components: {
    EventsCalendar
  },

  props: {
    orgId: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      stats: this.getStats(),
      fields: [
        {
          name: '__sequence',
          title: '#',
          width: 36
        },
        {
          name: 'status',
          title: 'Status',
          minWidth: 60,
          titleClass: 'hidden-md-and-down text-primary',
          dataClass: 'hidden-md-and-down text-primary'
        },
        {
          name: 'landowner',
          title: 'Landlord',
          minWidth: 225,
          visible: this.isTowerCo()
        },
        {
          name: 'siteName',
          title: 'Site Name',
          minWidth: 285
        },
        {
          name: 'years',
          title: 'Years',
          minWidth: 55,
          callback: this.formatInteger,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'term',
          title: 'Term',
          minWidth: 50,
          callback: this.formatInteger,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'expiry',
          title: 'Expiry',
          minWidth: 110,
          callback: this.formatDate,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'nextPaymentDate',
          title: 'Date Due',
          minWidth: 100,
          callback: this.formatDate,
          titleClass: 'text-danger',
          dataClass: 'text-danger text-right'
        },
        {
          name: 'nextPayment',
          title: 'Due',
          minWidth: 125,
          callback: this.formatMoney,
          titleClass: 'text-danger',
          dataClass: 'text-danger text-right'
        },
        {
          name: 'paid',
          title: 'Paid',
          minWidth: 135,
          callback: this.formatMoney,
          titleClass: 'hidden-sm-and-down text-success',
          dataClass: 'hidden-sm-and-down text-success text-right'
        },
        {
          name: 'outstanding',
          title: 'O/S',
          minWidth: 145,
          callback: this.formatMoney,
          titleClass: 'hidden-xs-only text-warning',
          dataClass: 'hidden-xs-only text-warning text-right'
        }
      ]
    }
  }
}
</script>

<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
/* Tighten line-height to the legacy vuetable's ~41px row height (el-table's
   default ~23px line-height made rows ~48px). */
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
